module.exports = __webpack_public_path__ + "img/lc2.fab4172d.png";